var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h2',[_vm._v("Advertisers (Upcoming) ")]),_c('ul',[_c('li',[_vm._v(" Job posting ")]),_c('li',[_vm._v(" Resume search ")]),_c('li',[_vm._v(" Applicant tracking. ")])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')])
}]

export { render, staticRenderFns }